import React from "react";
import { useLanguage } from "@/App";
import { ArrowLeft } from "lucide-react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const AlgemeneVoorwaarden = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navigation />
      <div className="pt-32 pb-24 max-w-4xl mx-auto px-6 md:px-12">
        <a href="/" className="inline-flex items-center gap-2 text-[#FF6B00] text-sm font-bold mb-8 hover:underline">
          <ArrowLeft size={16} />
          {language === "nl" ? "Terug naar home" : "Back to home"}
        </a>

        <h1 className="text-4xl sm:text-5xl font-black text-white mb-8" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
          {language === "nl" ? "Algemene Voorwaarden" : "Terms & Conditions"}
        </h1>

        <div className="prose prose-invert prose-zinc max-w-none space-y-8 text-zinc-300 leading-relaxed">
          {language === "nl" ? (
            <>
              <p className="text-zinc-400 text-sm">Laatst bijgewerkt: {new Date().toLocaleDateString("nl-NL", { year: "numeric", month: "long", day: "numeric" })}</p>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>1. Definities</h2>
                <p>In deze algemene voorwaarden wordt verstaan onder:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong className="text-white">EG Solutions:</strong> EG Solutions, gevestigd te Torenallee 101, 5617BR Eindhoven, KvK-nummer 99681293.</li>
                  <li><strong className="text-white">Opdrachtgever:</strong> de natuurlijke of rechtspersoon die aan EG Solutions opdracht heeft gegeven tot het verrichten van werkzaamheden.</li>
                  <li><strong className="text-white">Overeenkomst:</strong> de overeenkomst tot dienstverlening tussen EG Solutions en Opdrachtgever.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>2. Toepasselijkheid</h2>
                <p>Deze algemene voorwaarden zijn van toepassing op alle aanbiedingen, offertes, werkzaamheden, bestellingen, overeenkomsten en leveringen van diensten of producten door of namens EG Solutions.</p>
                <p>Afwijkingen van deze voorwaarden zijn slechts geldig indien deze uitdrukkelijk schriftelijk zijn overeengekomen.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>3. Aanbiedingen en Offertes</h2>
                <p>Alle aanbiedingen en offertes van EG Solutions zijn vrijblijvend, tenzij in het aanbod schriftelijk uitdrukkelijk anders is aangegeven. Een aanbod of offerte is maximaal 30 dagen geldig, tenzij een andere aanvaardingstermijn in het aanbod of de offerte staat vermeld.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>4. Prijzen en Betalingen</h2>
                <p>Alle prijzen die EG Solutions hanteert zijn in euro's, exclusief BTW en eventuele andere kosten zoals administratiekosten, heffingen en reis-, verzend- of transportkosten, tenzij uitdrukkelijk anders vermeld.</p>
                <p>Betaling dient te geschieden binnen 14 dagen na factuurdatum, op een door EG Solutions aan te geven wijze. Bij projecten geldt: 50% bij aanvang, 50% bij oplevering, tenzij anders overeengekomen.</p>
                <p>Online betalingen via onze website worden verwerkt via Stripe, een beveiligde betalingsprovider.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>5. Uitvoering van de Overeenkomst</h2>
                <p>EG Solutions zal de overeenkomst naar beste inzicht en vermogen uitvoeren. EG Solutions heeft het recht bepaalde werkzaamheden te laten verrichten door derden.</p>
                <p>De Opdrachtgever draagt er zorg voor dat alle gegevens waarvan EG Solutions aangeeft dat deze noodzakelijk zijn, tijdig worden verstrekt.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>6. Intellectueel Eigendom</h2>
                <p>Alle rechten van intellectueel eigendom op alle in het kader van de opdracht ontwikkelde of ter beschikking gestelde werken berusten bij EG Solutions, tenzij schriftelijk anders is overeengekomen.</p>
                <p>Na volledige betaling verkrijgt de Opdrachtgever een exclusief gebruiksrecht op het eindproduct.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>7. Aansprakelijkheid</h2>
                <p>EG Solutions is niet aansprakelijk voor schade die het gevolg is van onjuiste of onvolledige informatie verstrekt door de Opdrachtgever. De aansprakelijkheid van EG Solutions is beperkt tot het bedrag dat in het desbetreffende geval door de aansprakelijkheidsverzekering wordt uitbetaald, of bij gebreke daarvan, tot maximaal het factuurbedrag.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>8. Opzegging en Annulering</h2>
                <p>Beide partijen kunnen de overeenkomst schriftelijk opzeggen met inachtneming van een opzegtermijn van 30 dagen. Bij voortijdige beëindiging door de Opdrachtgever zijn de reeds verrichte werkzaamheden verschuldigd.</p>
                <p>Maandelijkse abonnementen (hosting, onderhoud) kunnen maandelijks worden opgezegd met een opzegtermijn van 30 dagen.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>9. Overmacht</h2>
                <p>EG Solutions is niet gehouden tot het nakomen van enige verplichting indien zij daartoe gehinderd wordt als gevolg van overmacht. Onder overmacht wordt verstaan elke van de wil onafhankelijke omstandigheid.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>10. Toepasselijk Recht</h2>
                <p>Op alle overeenkomsten is uitsluitend het Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter in het arrondissement Oost-Brabant.</p>
              </section>

              <section className="border-t border-white/10 pt-8 mt-12">
                <h2 className="text-xl font-bold text-white mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Contactgegevens</h2>
                <p>EG Solutions<br />Torenallee 101, 5617BR Eindhoven<br />KvK: 99681293 | BTW: NL005404414B27<br />Telefoon: +31 6 84006668</p>
              </section>
            </>
          ) : (
            <>
              <p className="text-zinc-400 text-sm">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>1. Definitions</h2>
                <p>In these terms and conditions, the following definitions apply:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong className="text-white">EG Solutions:</strong> EG Solutions, located at Torenallee 101, 5617BR Eindhoven, Chamber of Commerce number 99681293.</li>
                  <li><strong className="text-white">Client:</strong> the natural or legal person who has commissioned EG Solutions to perform work.</li>
                  <li><strong className="text-white">Agreement:</strong> the service agreement between EG Solutions and the Client.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>2. Applicability</h2>
                <p>These general terms and conditions apply to all offers, quotations, work, orders, agreements, and deliveries of services or products by or on behalf of EG Solutions.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>3. Offers and Quotations</h2>
                <p>All offers and quotations from EG Solutions are without obligation unless expressly stated otherwise. An offer or quotation is valid for a maximum of 30 days.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>4. Prices and Payments</h2>
                <p>All prices are in euros, excluding VAT unless stated otherwise. Payment is due within 14 days of the invoice date. For projects: 50% at start, 50% upon delivery, unless otherwise agreed. Online payments are processed securely via Stripe.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>5. Execution of the Agreement</h2>
                <p>EG Solutions will execute the agreement to the best of its knowledge and ability. EG Solutions has the right to have certain work performed by third parties.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>6. Intellectual Property</h2>
                <p>All intellectual property rights to all works developed remain with EG Solutions unless otherwise agreed in writing. After full payment, the Client receives an exclusive right of use of the final product.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>7. Liability</h2>
                <p>EG Solutions is not liable for damages resulting from incorrect or incomplete information provided by the Client. Liability is limited to the amount paid out by the liability insurance, or failing that, to the invoice amount.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>8. Termination</h2>
                <p>Both parties may terminate the agreement in writing with 30 days' notice. Monthly subscriptions can be cancelled monthly with 30 days' notice.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>9. Force Majeure</h2>
                <p>EG Solutions is not obliged to fulfill any obligation if prevented by force majeure.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-white mt-8 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>10. Applicable Law</h2>
                <p>All agreements are exclusively governed by Dutch law. Disputes shall be submitted to the competent court in the district of Oost-Brabant.</p>
              </section>

              <section className="border-t border-white/10 pt-8 mt-12">
                <h2 className="text-xl font-bold text-white mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Contact Details</h2>
                <p>EG Solutions<br />Torenallee 101, 5617BR Eindhoven<br />CoC: 99681293 | VAT: NL005404414B27<br />Phone: +31 6 84006668</p>
              </section>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AlgemeneVoorwaarden;
